exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rec-items[data-v-c942e076]{display:-webkit-box;display:-ms-flexbox;display:flex}.rec-items .rec-item__image-wrap[data-v-c942e076]{-webkit-box-flex:1;-ms-flex:1;flex:1}", ""]);

// exports
